import { createSelector } from "@reduxjs/toolkit";
import { State } from "redux/store";
import { UserInfo, UserQuota } from "types";

const userState = (state: State) => {
  return state.user;
};

export const getUserInfo = createSelector(userState, (state): UserInfo => {
  return state.userInfo;
});

export const getUserQuota = createSelector(
  userState,
  (state): UserQuota | null => {
    return state.userQuota;
  },
);
